import * as yup from 'yup';

/** Query param name for SP location on accept / accept-conditionally PUT. */
export const SERVICE_PROVIDER_LOCATION_ID_PARAM = 'locationId';

export function buildAcceptanceLocationYupFields(formatMessage) {
  return {
    acceptanceLocation: yup.mixed().test(
      'acceptance-location-required',
      formatMessage({
        id: 'ACCEPT_JOB_LOCATION_REQUIRED',
        defaultMessage: 'Location is required',
      }),
      val =>
        val != null &&
        typeof val === 'object' &&
        val.value != null &&
        val.value !== '',
    ),
  };
}

export async function fetchActiveServiceProviderLocations(
  get,
  getApiUrl,
  serviceProviderId,
) {
  if (!serviceProviderId) {
    return [];
  }
  const url = `${getApiUrl()}/sxcl/v1/service-providers/${serviceProviderId}/locations/?status=$eq:ACTIVE&limit=100`;
  const response = await get(url);
  if (!response?.ok) {
    return [];
  }
  return response?.data?.data ?? [];
}

/**
 * @param {object} data
 * @param {{ activeCount: number, singleLocationId: string | null }} options
 * @returns {string | null}
 */
export function getAcceptanceLocationIdFromForm(
  data,
  { activeCount, singleLocationId },
) {
  if (activeCount > 1) {
    return data?.acceptanceLocation?.value ?? null;
  }
  if (activeCount === 1) {
    return singleLocationId;
  }
  return null;
}

/**
 * @param {Array<{ id: string, locationName: string, isDefaultLocation?: boolean }>} activeLocations
 * @param {object} [dispatchEvent]
 * @param {object} [dispatchEvent.acceptedLocation] When present with a resolvable id, used before other dispatch location fields (`id`, `serviceProviderLocationId`, `locationId`; label from list or `locationName` / `name`).
 * @returns {{ label: string, value: string } | null}
 */
export function getDefaultAcceptLocationOption(activeLocations, dispatchEvent) {
  const accepted = dispatchEvent?.acceptedLocation;
  if (accepted != null && typeof accepted === 'object') {
    const acceptedLocationId =
      accepted.id ??
      accepted.serviceProviderLocationId ??
      accepted.locationId ??
      null;
    if (acceptedLocationId) {
      const match = activeLocations.find(l => l.id === acceptedLocationId);
      if (match) {
        return { label: match.locationName, value: match.id };
      }
      return {
        label: accepted.locationName ?? accepted.name ?? '',
        value: acceptedLocationId,
      };
    }
  }
  const dispatchLocationId =
    dispatchEvent?.serviceProviderLocationId ??
    dispatchEvent?.locationId ??
    null;
  if (dispatchLocationId) {
    const match = activeLocations.find(l => l.id === dispatchLocationId);
    if (match) {
      return { label: match.locationName, value: match.id };
    }
  }
  const defaultLoc = activeLocations.find(l => l.isDefaultLocation === true);
  if (defaultLoc) {
    return { label: defaultLoc.locationName, value: defaultLoc.id };
  }
  return null;
}
